import React, { useState, useMemo, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import api from '../api';

// ─── FIFA Rankings (April 1, 2026) ───────────────────────────────────────────
const FIFA_RANKINGS = [
  { rank:1,  country:'France',        iso:'fr',     pts:1877.32, wc:true  },
  { rank:2,  country:'Spain',         iso:'es',     pts:1876.40, wc:true  },
  { rank:3,  country:'Argentina',     iso:'ar',     pts:1874.82, wc:true  },
  { rank:4,  country:'England',       iso:'gb-eng', pts:1825.97, wc:true  },
  { rank:5,  country:'Portugal',      iso:'pt',     pts:1763.83, wc:true  },
  { rank:6,  country:'Brazil',        iso:'br',     pts:1761.16, wc:true  },
  { rank:7,  country:'Netherlands',   iso:'nl',     pts:1757.87, wc:true  },
  { rank:8,  country:'Morocco',       iso:'ma',     pts:1756.80, wc:true  },
  { rank:9,  country:'Belgium',       iso:'be',     pts:1734.72, wc:true  },
  { rank:10, country:'Germany',       iso:'de',     pts:1730.37, wc:true  },
  { rank:11, country:'Croatia',       iso:'hr',     pts:1717.06, wc:true  },
  { rank:12, country:'Colombia',      iso:'co',     pts:1693.09, wc:true  },
  { rank:13, country:'Senegal',       iso:'sn',     pts:1691.97, wc:true  },
  { rank:14, country:'Italy',         iso:'it',     pts:1687.98, wc:false },
  { rank:15, country:'Mexico',        iso:'mx',     pts:1681.03, wc:true  },
  { rank:16, country:'USA',           iso:'us',     pts:1673.13, wc:true  },
  { rank:17, country:'Uruguay',       iso:'uy',     pts:1673.07, wc:true  },
  { rank:18, country:'Japan',         iso:'jp',     pts:1660.43, wc:true  },
  { rank:19, country:'Switzerland',   iso:'ch',     pts:1649.40, wc:true  },
  { rank:20, country:'Iran',          iso:'ir',     pts:1615.30, wc:true  },
  { rank:21, country:'Denmark',       iso:'dk',     pts:1608.45, wc:false },
  { rank:22, country:'Türkiye',       iso:'tr',     pts:1599.03, wc:true  },
  { rank:23, country:'Ecuador',       iso:'ec',     pts:1594.79, wc:true  },
  { rank:24, country:'Austria',       iso:'at',     pts:1593.45, wc:true  },
  { rank:25, country:'South Korea',   iso:'kr',     pts:1588.67, wc:true  },
  { rank:26, country:'Nigeria',       iso:'ng',     pts:1585.08, wc:false },
  { rank:27, country:'Australia',     iso:'au',     pts:1580.68, wc:true  },
  { rank:28, country:'Algeria',       iso:'dz',     pts:1564.26, wc:true  },
  { rank:29, country:'Egypt',         iso:'eg',     pts:1563.24, wc:true  },
  { rank:30, country:'Canada',        iso:'ca',     pts:1556.48, wc:true  },
  { rank:31, country:'Norway',        iso:'no',     pts:1550.95, wc:true  },
  { rank:32, country:'Ukraine',       iso:'ua',     pts:1546.88, wc:false },
  { rank:33, country:'Panama',        iso:'pa',     pts:1540.64, wc:true  },
  { rank:34, country:"Côte d'Ivoire", iso:'ci',     pts:1532.97, wc:true  },
  { rank:35, country:'Poland',        iso:'pl',     pts:1528.00, wc:false },
  { rank:36, country:'Russia',        iso:'ru',     pts:1525.60, wc:false, banned:true },
  { rank:37, country:'Sweden',        iso:'se',     pts:1514.77, wc:true  },
  { rank:38, country:'Czechia',       iso:'cz',     pts:1513.74, wc:true  },
  { rank:39, country:'Wales',         iso:'gb-wls', pts:1511.90, wc:false },
  { rank:40, country:'Serbia',        iso:'rs',     pts:1508.65, wc:false },
  { rank:41, country:'Paraguay',      iso:'py',     pts:1503.51, wc:true  },
  { rank:42, country:'Hungary',       iso:'hu',     pts:1500.58, wc:false },
  { rank:43, country:'Scotland',      iso:'gb-sct', pts:1498.35, wc:true  },
  { rank:44, country:'Tunisia',       iso:'tn',     pts:1483.05, wc:true  },
  { rank:45, country:'Cameroon',      iso:'cm',     pts:1481.24, wc:false },
  { rank:46, country:'DR Congo',      iso:'cd',     pts:1479.64, wc:true  },
  { rank:47, country:'Greece',        iso:'gr',     pts:1475.82, wc:false },
  { rank:48, country:'Slovakia',      iso:'sk',     pts:1473.94, wc:false },
  { rank:49, country:'Uzbekistan',    iso:'uz',     pts:1469.40, wc:true  },
  { rank:50, country:'Venezuela',     iso:'ve',     pts:1463.03, wc:false },
];

// ─── Fun Facts ────────────────────────────────────────────────────────────────
const FACTS = [
  { icon:'📏', category:'Scale',      title:'Biggest expansion ever',        body:'48 teams, 104 matches, 39 days — a 63% jump from the 64-match format used since 1998. More goals, more upsets, more chaos.' },
  { icon:'🆕', category:'Format',     title:'A brand-new round',             body:'The Round of 32 is a World Cup first. Two-thirds of all 48 teams advance out of the group stage — finishing 3rd in your group no longer means going home.' },
  { icon:'📅', category:'Format',     title:'Eight matches to the title',    body:'Teams reaching the Final now play 8 matches — the heaviest schedule in World Cup history, tested over the full length of North American summer.' },
  { icon:'💰', category:'Prize Money',title:'$871 million total prize pot',  body:'The champion takes home $50 million (up from $42M in 2022). Every qualified team is guaranteed at least $12.5 million just for showing up — a record floor payment.' },
  { icon:'🌎', category:'Hosting',    title:'First three-nation World Cup',  body:'The USA hosts 11 cities, Mexico 3, Canada 2 — 16 venues spread across an entire continent. Never before have three countries shared a men\'s World Cup.' },
  { icon:'🏟️', category:'Hosting',   title:'Mexico\'s third rodeo',         body:'Mexico becomes the first country to host the men\'s World Cup three times (1970, 1986, 2026). The Estadio Azteca will host matches at all three — the only stadium in history to do so.' },
  { icon:'⭐', category:'Rankings',   title:'The tightest top-3 ever',       body:'France, Spain, and Argentina entered the tournament separated by just 2.50 FIFA ranking points — the narrowest top-3 gap in rankings history heading into a World Cup.' },
  { icon:'😬', category:'Absences',   title:'Italy misses another one',      body:'Italy (ranked 14th in the world) failed to qualify for a third consecutive major tournament, following their shock absences in 2018 and 2022.' },
  { icon:'👴', category:'Players',    title:'The last dance — times two',    body:'Both Lionel Messi (Argentina, ~39) and Cristiano Ronaldo (Portugal, ~41) are expected to feature, potentially becoming the first players to appear in six separate World Cups.' },
  { icon:'🧤', category:'Players',    title:'Memo Ochoa: six World Cups',    body:'Mexico\'s goalkeeper Guillermo Ochoa turns 40 during the tournament and could make his sixth World Cup appearance — matching the all-time record for most appearances by a goalkeeper.' },
  { icon:'⚽', category:'Players',    title:'Modric, still going',           body:'Croatia\'s Luka Modric (age 40) remains in the squad, putting him in contention for a fifth World Cup appearance after 2022\'s bronze-medal finish.' },
  { icon:'📺', category:'Viewership', title:'1.5 billion watched 2022',      body:'The Qatar 2022 Final drew an estimated 1.5 billion TV viewers — 13× the Super Bowl audience. North American time zones are expected to break that record in 2026.' },
  { icon:'🌍', category:'Debutants',  title:'Four first-time qualifiers',    body:'Cape Verde, Curaçao, Jordan, and Uzbekistan are all making their World Cup debut in 2026. Uzbekistan (ranked 49th) is the highest-ranked first-time qualifier in recent memory.' },
  { icon:'🏗️', category:'Stadiums',  title:'The $5.5 billion stadium',      body:'SoFi Stadium in Los Angeles cost $5.5 billion to build — the most expensive sports facility ever constructed — with a first-of-its-kind indoor/outdoor hybrid design.' },
  { icon:'❄️', category:'Stadiums',  title:'Climate-controlled World Cup',  body:'Four venues — Atlanta, Dallas, Houston, and Vancouver — are fully enclosed or retractable-roof stadiums with climate control. Unprecedented for a World Cup.' },
  { icon:'📢', category:'Stadiums',  title:'Loudest sports venue on Earth', body:'Arrowhead Stadium in Kansas City holds the Guinness World Record for loudest crowd noise ever recorded — 142.2 decibels in 2014, louder than a jet engine at takeoff.' },
  { icon:'🏆', category:'History',   title:'Argentina: defending champions',body:'Argentina won the 2022 World Cup in Qatar, ending a 36-year title drought. Separated from 1st-place France by less than 3 FIFA ranking points entering 2026.' },
  { icon:'📐', category:'Stadiums',  title:'The iris roof',                  body:'Mercedes-Benz Stadium in Atlanta has a retractable roof that opens like the iris of a camera — 8 triangular steel panels fold back to reveal the sky. No other stadium in the world has anything like it.' },
];

// ─── Squads ───────────────────────────────────────────────────────────────────
const SQUADS = {
  USA: {
    flag:'us', coach:'Mauricio Pochettino', group:'D',
    note:'Official 26-man roster — announced May 26, 2026',
    players:[
      { name:'Matt Turner',          pos:'GK',  club:'New England Revolution',   age:31 },
      { name:'Matt Freese',          pos:'GK',  club:'New York City FC',          age:27 },
      { name:'Chris Brady',          pos:'GK',  club:'Chicago Fire FC',           age:22 },
      { name:'Antonee Robinson',     pos:'DEF', club:'Fulham',                    age:28 },
      { name:'Sergiño Dest',         pos:'DEF', club:'PSV Eindhoven',             age:23 },
      { name:'Chris Richards',       pos:'DEF', club:'Crystal Palace',            age:26 },
      { name:'Auston Trusty',        pos:'DEF', club:'Celtic',                    age:27 },
      { name:'Miles Robinson',       pos:'DEF', club:'FC Cincinnati',             age:29 },
      { name:'Mark McKenzie',        pos:'DEF', club:'Toulouse',                  age:27 },
      { name:'Tim Ream',             pos:'DEF', club:'Charlotte FC',              age:38 },
      { name:'Max Arfsten',          pos:'DEF', club:'Columbus Crew',             age:25 },
      { name:'Alex Freeman',         pos:'DEF', club:'Villarreal',                age:21 },
      { name:'Joe Scally',           pos:'DEF', club:'Borussia Mönchengladbach',  age:23 },
      { name:'Tyler Adams',          pos:'MID', club:'Bournemouth',               age:27 },
      { name:'Weston McKennie',      pos:'MID', club:'Juventus',                  age:27 },
      { name:'Gio Reyna',            pos:'MID', club:'Borussia Mönchengladbach',  age:23 },
      { name:'Malik Tillman',        pos:'MID', club:'Bayer Leverkusen',          age:24 },
      { name:'Cristian Roldan',      pos:'MID', club:'Seattle Sounders',          age:31 },
      { name:'Sebastian Berhalter',  pos:'MID', club:'Vancouver Whitecaps',       age:25 },
      { name:'Christian Pulisic',    pos:'FWD', club:'AC Milan',                  age:27 },
      { name:'Folarin Balogun',      pos:'FWD', club:'Monaco',                    age:24 },
      { name:'Ricardo Pepi',         pos:'FWD', club:'PSV Eindhoven',             age:23 },
      { name:'Haji Wright',          pos:'FWD', club:'Coventry City',             age:28 },
      { name:'Timothy Weah',         pos:'FWD', club:'Marseille',                 age:26 },
      { name:'Brenden Aaronson',     pos:'FWD', club:'Leeds United',              age:25 },
      { name:'Alejandro Zendejas',   pos:'FWD', club:'Club América',              age:28 },
    ],
  },
  Mexico: {
    flag:'mx', coach:'Javier Aguirre', group:'A',
    note:'Official 26-man squad — announced June 1, 2026',
    players:[
      { name:'Guillermo Ochoa',      pos:'GK',  club:'AEL Limassol',             age:41 },
      { name:'Carlos Acevedo',       pos:'GK',  club:'Santos Laguna',             age:30 },
      { name:'Raúl Rangel',          pos:'GK',  club:'Guadalajara',               age:26 },
      { name:'Israel Reyes',         pos:'DEF', club:'Club América',              age:26 },
      { name:'Jorge Sánchez',        pos:'DEF', club:'PAOK',                      age:28 },
      { name:'César Montes',         pos:'DEF', club:'Lokomotiv Moscow',          age:29 },
      { name:'Johan Vásquez',        pos:'DEF', club:'Genoa',                     age:27 },
      { name:'Jesús Gallardo',       pos:'DEF', club:'Toluca',                    age:31 },
      { name:'Mateo Chávez',         pos:'DEF', club:'AZ Alkmaar',                age:22 },
      { name:'Edson Álvarez',        pos:'MID', club:'Fenerbahçe',                age:28, captain:true },
      { name:'Álvaro Fidalgo',       pos:'MID', club:'Real Betis',                age:28 },
      { name:'Bryan Gutiérrez',      pos:'MID', club:'Guadalajara',               age:22 },
      { name:'Orbelín Pineda',       pos:'MID', club:'AEK Athens',                age:30 },
      { name:'Erik Lira',            pos:'MID', club:'Cruz Azul',                 age:26 },
      { name:'Luis Romo',            pos:'MID', club:'Guadalajara',               age:31 },
      { name:'Obed Vargas',          pos:'MID', club:'Atlético Madrid',           age:20 },
      { name:'Gilberto Mora',        pos:'MID', club:'Club Tijuana',              age:17 },
      { name:'Luis Chávez',          pos:'MID', club:'Dynamo Moscow',             age:31 },
      { name:'Raúl Jiménez',         pos:'FWD', club:'Fulham',                    age:35 },
      { name:'César Huerta',         pos:'FWD', club:'Anderlecht',                age:26 },
      { name:'Santiago Giménez',     pos:'FWD', club:'AC Milan',                  age:24 },
      { name:'Alexis Vega',          pos:'FWD', club:'Toluca',                    age:28 },
      { name:'Roberto Alvarado',     pos:'FWD', club:'Guadalajara',               age:27 },
      { name:'Julián Quiñones',      pos:'FWD', club:'Al-Qadisiyah',              age:29 },
      { name:'Guillermo Martínez',   pos:'FWD', club:'Pumas UNAM',                age:31 },
      { name:'Armando González',     pos:'FWD', club:'Guadalajara',               age:23 },
    ],
  },
  Canada: {
    flag:'ca', coach:'Jesse Marsch', group:'B',
    note:'Official 26-man squad — announced May 29, 2026',
    players:[
      { name:'Maxime Crépeau',         pos:'GK',  club:'Orlando City SC',          age:32 },
      { name:'Dayne St. Clair',        pos:'GK',  club:'Inter Miami CF',           age:29 },
      { name:'Owen Goodman',           pos:'GK',  club:'Barnsley',                 age:22 },
      { name:'Alphonso Davies',        pos:'DEF', club:'Bayern Munich',            age:25, captain:true },
      { name:'Alistair Johnston',      pos:'DEF', club:'Celtic',                   age:27 },
      { name:'Moïse Bombito',          pos:'DEF', club:'OGC Nice',                 age:26 },
      { name:'Derek Cornelius',        pos:'DEF', club:'Rangers',                  age:28 },
      { name:'Richie Laryea',          pos:'DEF', club:'Toronto FC',               age:31 },
      { name:'Niko Sigur',             pos:'DEF', club:'Hajduk Split',             age:22 },
      { name:'Alfie Jones',            pos:'DEF', club:'Middlesbrough',            age:28 },
      { name:'Joel Waterman',          pos:'DEF', club:'Chicago Fire FC',          age:30 },
      { name:'Luc de Fougerolles',     pos:'DEF', club:'Dender',                   age:20 },
      { name:'Stephen Eustáquio',      pos:'MID', club:'LAFC',                     age:29 },
      { name:'Ismaël Koné',            pos:'MID', club:'Sassuolo',                 age:23 },
      { name:'Jonathan Osorio',        pos:'MID', club:'Toronto FC',               age:33 },
      { name:'Mathieu Choinière',      pos:'MID', club:'LAFC',                     age:27 },
      { name:'Nathan Saliba',          pos:'MID', club:'Anderlecht',               age:22 },
      { name:'Tajon Buchanan',         pos:'MID', club:'Villarreal',               age:27 },
      { name:'Jacob Shaffelburg',      pos:'MID', club:'LAFC',                     age:26 },
      { name:'Liam Millar',            pos:'MID', club:'Hull City',                age:26 },
      { name:'Jayden Nelson',          pos:'MID', club:'Austin FC',                age:23 },
      { name:'Ali Ahmed',              pos:'MID', club:'Norwich City',             age:25 },
      { name:'Jonathan David',         pos:'FWD', club:'Juventus',                 age:26 },
      { name:'Cyle Larin',             pos:'FWD', club:'Southampton',              age:31 },
      { name:'Tani Oluwaseyi',         pos:'FWD', club:'Villarreal',               age:26 },
      { name:'Promise David',          pos:'FWD', club:'Union Saint-Gilloise',     age:24 },
    ],
  },
  'New Zealand': {
    flag:'nz', coach:'Darren Bazeley', group:'G',
    note:'Official 26-man squad — announced May 14, 2026',
    players:[
      { name:'Max Crocombe',       pos:'GK',  club:'Millwall',                 age:32 },
      { name:'Alex Paulsen',       pos:'GK',  club:'Lechia Gdańsk',            age:23 },
      { name:'Michael Woud',       pos:'GK',  club:'Auckland FC',              age:27 },
      { name:'Tim Payne',          pos:'DEF', club:'Wellington Phoenix',       age:31 },
      { name:'Francis De Vries',   pos:'DEF', club:'Auckland FC',              age:33 },
      { name:'Tyler Bindon',       pos:'DEF', club:'Nottingham Forest',        age:21 },
      { name:'Michael Boxall',     pos:'DEF', club:'Minnesota United',         age:37 },
      { name:'Liberato Cacace',    pos:'DEF', club:'Wrexham',                  age:25 },
      { name:'Nando Pijnaker',     pos:'DEF', club:'Auckland FC',              age:26 },
      { name:'Finn Surman',        pos:'DEF', club:'Portland Timbers',         age:23 },
      { name:'Callan Elliot',      pos:'DEF', club:'Auckland FC',              age:26 },
      { name:'Tommy Smith',        pos:'DEF', club:'Braintree Town',           age:36 },
      { name:'Ryan Thomas',        pos:'MID', club:'PEC Zwolle',               age:31 },
      { name:'Alex Rufer',         pos:'MID', club:'Wellington Phoenix',       age:29 },
      { name:'Joe Bell',           pos:'MID', club:'Viking FK',                age:27 },
      { name:'Marko Stamenić',     pos:'MID', club:'Swansea City',             age:24 },
      { name:'Lachlan Bayliss',    pos:'MID', club:'Newcastle Jets',           age:23 },
      { name:'Matt Garbett',       pos:'MID', club:'Peterborough United',      age:24 },
      { name:'Ben Old',            pos:'MID', club:'AS Saint-Étienne',         age:23 },
      { name:'Sarpreet Singh',     pos:'MID', club:'Wellington Phoenix',       age:27 },
      { name:'Chris Wood',         pos:'FWD', club:'Nottingham Forest',        age:34, captain:true },
      { name:'Kosta Barbarouses',  pos:'FWD', club:'Western Sydney Wanderers', age:36 },
      { name:'Elijah Just',        pos:'FWD', club:'Motherwell',               age:25 },
      { name:'Callum McCowatt',    pos:'FWD', club:'Silkeborg IF',             age:26 },
      { name:'Jesse Randall',      pos:'FWD', club:'Auckland FC',              age:25 },
      { name:'Ben Waine',          pos:'FWD', club:'Port Vale',                age:24 },
    ],
  },
  England: {
    flag:'gb-eng', coach:'Thomas Tuchel', group:'L',
    note:'Official 26-man squad — announced May 22, 2026',
    players:[
      { name:'Jordan Pickford',    pos:'GK',  club:'Everton',              age:32 },
      { name:'Dean Henderson',     pos:'GK',  club:'Crystal Palace',       age:29 },
      { name:'James Trafford',     pos:'GK',  club:'Manchester City',      age:23 },
      { name:'Ezri Konsa',         pos:'DEF', club:'Aston Villa',          age:28 },
      { name:'Nico O\'Reilly',     pos:'DEF', club:'Manchester City',      age:20 },
      { name:'John Stones',        pos:'DEF', club:'Manchester City',      age:32 },
      { name:'Marc Guéhi',         pos:'DEF', club:'Manchester City',      age:25 },
      { name:'Trevoh Chalobah',    pos:'DEF', club:'Chelsea',              age:26 },
      { name:'Dan Burn',           pos:'DEF', club:'Newcastle United',     age:34 },
      { name:'Reece James',        pos:'DEF', club:'Chelsea',              age:25 },
      { name:'Djed Spence',        pos:'DEF', club:'Tottenham Hotspur',    age:25 },
      { name:'Jarell Quansah',     pos:'DEF', club:'Bayer Leverkusen',     age:23 },
      { name:'Declan Rice',        pos:'MID', club:'Arsenal',              age:27 },
      { name:'Jude Bellingham',    pos:'MID', club:'Real Madrid',          age:22 },
      { name:'Jordan Henderson',   pos:'MID', club:'Brentford',            age:35 },
      { name:'Kobbie Mainoo',      pos:'MID', club:'Manchester United',    age:21 },
      { name:'Morgan Rogers',      pos:'MID', club:'Aston Villa',          age:23 },
      { name:'Eberechi Eze',       pos:'MID', club:'Arsenal',              age:27 },
      { name:'Elliot Anderson',    pos:'MID', club:'Nottingham Forest',    age:23 },
      { name:'Bukayo Saka',        pos:'FWD', club:'Arsenal',              age:24 },
      { name:'Harry Kane',         pos:'FWD', club:'Bayern Munich',        age:32, captain:true },
      { name:'Marcus Rashford',    pos:'FWD', club:'Manchester United',    age:28 },
      { name:'Anthony Gordon',     pos:'FWD', club:'Barcelona',            age:25 },
      { name:'Ollie Watkins',      pos:'FWD', club:'Aston Villa',          age:30 },
      { name:'Noni Madueke',       pos:'FWD', club:'Arsenal',              age:23 },
      { name:'Ivan Toney',         pos:'FWD', club:'Al-Ahli',              age:30 },
    ],
  },
  Iran: {
    flag:'ir', coach:'Amir Ghalenoei', group:'G',
    note:'Official 26-man squad — June 2026',
    players:[
      { name:'Alireza Beiranvand',        pos:'GK',  club:'Tractor SC',         age:33 },
      { name:'Hossein Hosseini',          pos:'GK',  club:'Sepahan',            age:33 },
      { name:'Payam Niazmand',            pos:'GK',  club:'Persepolis',         age:31 },
      { name:'Ehsan Hajsafi',             pos:'DEF', club:'Sepahan',            age:36 },
      { name:'Milad Mohammadi',           pos:'DEF', club:'Persepolis',         age:32 },
      { name:'Ramin Rezaeian',            pos:'DEF', club:'Foolad',             age:36 },
      { name:'Hossein Kanaanizadegan',    pos:'DEF', club:'Persepolis',         age:32 },
      { name:'Shojae Khalilzadeh',        pos:'DEF', club:'Tractor SC',         age:37 },
      { name:'Saleh Hardani',             pos:'DEF', club:'Esteghlal',          age:27 },
      { name:'Ali Nemati',                pos:'DEF', club:'Foolad',             age:30 },
      { name:'Danial Eiri',               pos:'DEF', club:'Malavan',            age:22 },
      { name:'Alireza Jahanbakhsh',       pos:'MID', club:'Dender',             age:32, captain:true },
      { name:'Saeid Ezatolahi',           pos:'MID', club:'Shabab Al-Ahli',     age:29 },
      { name:'Saman Ghoddos',            pos:'MID', club:'Ittihad Kalba',      age:32 },
      { name:'Mehdi Torabi',              pos:'MID', club:'Tractor SC',         age:31 },
      { name:'Rouzbeh Cheshmi',          pos:'MID', club:'Esteghlal',          age:32 },
      { name:'Mohammad Mohebi',           pos:'MID', club:'FC Rostov',          age:27 },
      { name:'Mehdi Ghayedi',             pos:'MID', club:'Al-Nasr',            age:27 },
      { name:'Mohammad Ghorbani',         pos:'MID', club:'Al Wahda',           age:25 },
      { name:'Aria Yousefi',              pos:'MID', club:'Sepahan',            age:24 },
      { name:'Amirmohammad Razzaghinia',  pos:'MID', club:'Esteghlal',          age:20 },
      { name:'Mehdi Taremi',              pos:'FWD', club:'Olympiacos',         age:33 },
      { name:'Shahriyar Moghanlou',       pos:'FWD', club:'Ittihad Kalba',      age:31 },
      { name:'Amirhossein Hosseinzadeh', pos:'FWD', club:'Tractor SC',         age:25 },
      { name:'Ali Alipour',               pos:'FWD', club:'Persepolis',         age:30 },
      { name:'Dennis Dargahi',            pos:'FWD', club:'Standard Liège',     age:29 },
    ],
  },
};

// ─── Betting Odds (to win WC 2026) ───────────────────────────────────────────
const ODDS = [
  { country:'France',        iso:'fr',     odds:400  },
  { country:'Spain',         iso:'es',     odds:550  },
  { country:'England',       iso:'gb-eng', odds:600  },
  { country:'Argentina',     iso:'ar',     odds:800  },
  { country:'Portugal',      iso:'pt',     odds:1000 },
  { country:'Brazil',        iso:'br',     odds:1100 },
  { country:'Germany',       iso:'de',     odds:1300 },
  { country:'Netherlands',   iso:'nl',     odds:1700 },
  { country:'Norway',        iso:'no',     odds:3000 },
  { country:'Belgium',       iso:'be',     odds:4000 },
  { country:'Morocco',       iso:'ma',     odds:4000 },
  { country:'USA',           iso:'us',     odds:4500 },
  { country:'Colombia',      iso:'co',     odds:5000 },
  { country:'Japan',         iso:'jp',     odds:5000 },
  { country:'Mexico',        iso:'mx',     odds:5500 },
  { country:'Switzerland',   iso:'ch',     odds:7500 },
  { country:'Croatia',       iso:'hr',     odds:9000 },
  { country:'Uruguay',       iso:'uy',     odds:10000},
  { country:'Senegal',       iso:'sn',     odds:10000},
  { country:'Sweden',        iso:'se',     odds:12000},
  { country:'Ecuador',       iso:'ec',     odds:12000},
  { country:'Australia',     iso:'au',     odds:15000},
  { country:'Canada',        iso:'ca',     odds:15000},
  { country:'Türkiye',       iso:'tr',     odds:15000},
  { country:'South Korea',   iso:'kr',     odds:15000},
  { country:'Austria',       iso:'at',     odds:16000},
  { country:"Côte d'Ivoire", iso:'ci',     odds:20000},
  { country:'Algeria',       iso:'dz',     odds:30000},
  { country:'Scotland',      iso:'gb-sct', odds:30000},
  { country:'Czechia',       iso:'cz',     odds:35000},
  { country:'Egypt',         iso:'eg',     odds:40000},
  { country:'Paraguay',      iso:'py',     odds:45000},
  { country:'Ghana',         iso:'gh',     odds:50000},
  { country:'Bosnia & Herz.',iso:'ba',     odds:70000},
  { country:'Saudi Arabia',  iso:'sa',     odds:80000},
  { country:'DR Congo',      iso:'cd',     odds:80000},
  { country:'Iran',          iso:'ir',     odds:100000},
  { country:'Tunisia',       iso:'tn',     odds:150000},
  { country:'South Africa',  iso:'za',     odds:200000},
  { country:'Cape Verde',    iso:'cv',     odds:250000},
  { country:'New Zealand',   iso:'nz',     odds:250000},
  { country:'Iraq',          iso:'iq',     odds:250000},
  { country:'Uzbekistan',    iso:'uz',     odds:250000},
  { country:'Panama',        iso:'pa',     odds:250000},
  { country:'Curaçao',       iso:'cw',     odds:250000},
  { country:'Haiti',         iso:'ht',     odds:250000},
  { country:'Qatar',         iso:'qa',     odds:250000},
  { country:'Jordan',        iso:'jo',     odds:250000},
];

// ─── Qualifiers by Confederation ─────────────────────────────────────────────
const CONFEDERATIONS = [
  { name:'UEFA', region:'Europe', color:'#003DA5', slots:16, teams:[
    { name:'France',       iso:'fr',     group:'I' },
    { name:'Spain',        iso:'es',     group:'H' },
    { name:'England',      iso:'gb-eng', group:'L' },
    { name:'Portugal',     iso:'pt',     group:'K' },
    { name:'Germany',      iso:'de',     group:'E' },
    { name:'Netherlands',  iso:'nl',     group:'F' },
    { name:'Belgium',      iso:'be',     group:'G' },
    { name:'Croatia',      iso:'hr',     group:'L' },
    { name:'Scotland',     iso:'gb-sct', group:'C' },
    { name:'Switzerland',  iso:'ch',     group:'B' },
    { name:'Sweden',       iso:'se',     group:'F' },
    { name:'Czechia',      iso:'cz',     group:'A' },
    { name:'Türkiye',      iso:'tr',     group:'D' },
    { name:'Austria',      iso:'at',     group:'J' },
    { name:'Norway',       iso:'no',     group:'I' },
    { name:'Bosnia & Herz.',iso:'ba',    group:'B' },
  ]},
  { name:'CONMEBOL', region:'South America', color:'#FFD700', slots:6, teams:[
    { name:'Brazil',    iso:'br', group:'C' },
    { name:'Argentina', iso:'ar', group:'J' },
    { name:'Uruguay',   iso:'uy', group:'H' },
    { name:'Colombia',  iso:'co', group:'K' },
    { name:'Ecuador',   iso:'ec', group:'E' },
    { name:'Paraguay',  iso:'py', group:'D' },
  ]},
  { name:'CONCACAF', region:'N./C. America & Caribbean', color:'#E63946', slots:6, teams:[
    { name:'USA',      iso:'us', group:'D', host:true },
    { name:'Mexico',   iso:'mx', group:'A', host:true },
    { name:'Canada',   iso:'ca', group:'B', host:true },
    { name:'Panama',   iso:'pa', group:'L' },
    { name:'Haiti',    iso:'ht', group:'C' },
    { name:'Curaçao',  iso:'cw', group:'E' },
  ]},
  { name:'CAF', region:'Africa', color:'#2DC653', slots:9, teams:[
    { name:'Morocco',       iso:'ma', group:'C' },
    { name:'Senegal',       iso:'sn', group:'I' },
    { name:'Egypt',         iso:'eg', group:'G' },
    { name:'Algeria',       iso:'dz', group:'J' },
    { name:'DR Congo',      iso:'cd', group:'K' },
    { name:'Ghana',         iso:'gh', group:'L' },
    { name:'South Africa',  iso:'za', group:'A' },
    { name:"Côte d'Ivoire", iso:'ci', group:'E' },
    { name:'Tunisia',       iso:'tn', group:'F' },
    { name:'Cape Verde',    iso:'cv', group:'H' },
  ]},
  { name:'AFC', region:'Asia', color:'#FF6B35', slots:8, teams:[
    { name:'Japan',        iso:'jp', group:'F' },
    { name:'South Korea',  iso:'kr', group:'A' },
    { name:'Iran',         iso:'ir', group:'G' },
    { name:'Saudi Arabia', iso:'sa', group:'H' },
    { name:'Australia',    iso:'au', group:'D' },
    { name:'Qatar',        iso:'qa', group:'B' },
    { name:'Iraq',         iso:'iq', group:'I' },
    { name:'Jordan',       iso:'jo', group:'J' },
    { name:'Uzbekistan',   iso:'uz', group:'K' },
  ]},
  { name:'OFC', region:'Oceania', color:'#7B2FBE', slots:1, teams:[
    { name:'New Zealand', iso:'nz', group:'G' },
  ]},
];

// ─── WC History ───────────────────────────────────────────────────────────────
const WC_HISTORY = [
  { year:1930, host:'Uruguay',        hostIso:'uy', winner:'Uruguay',      winIso:'uy', runnerUp:'Argentina',    ruIso:'ar', score:'4–2' },
  { year:1934, host:'Italy',          hostIso:'it', winner:'Italy',        winIso:'it', runnerUp:'Czechoslovakia',ruIso:'cz', score:'2–1 AET' },
  { year:1938, host:'France',         hostIso:'fr', winner:'Italy',        winIso:'it', runnerUp:'Hungary',       ruIso:'hu', score:'4–2' },
  { year:1950, host:'Brazil',         hostIso:'br', winner:'Uruguay',      winIso:'uy', runnerUp:'Brazil',        ruIso:'br', score:'Final group stage' },
  { year:1954, host:'Switzerland',    hostIso:'ch', winner:'West Germany', winIso:'de', runnerUp:'Hungary',       ruIso:'hu', score:'3–2' },
  { year:1958, host:'Sweden',         hostIso:'se', winner:'Brazil',       winIso:'br', runnerUp:'Sweden',        ruIso:'se', score:'5–2' },
  { year:1962, host:'Chile',          hostIso:'cl', winner:'Brazil',       winIso:'br', runnerUp:'Czechoslovakia',ruIso:'cz', score:'3–1' },
  { year:1966, host:'England',        hostIso:'gb-eng', winner:'England',  winIso:'gb-eng', runnerUp:'West Germany', ruIso:'de', score:'4–2 AET' },
  { year:1970, host:'Mexico',         hostIso:'mx', winner:'Brazil',       winIso:'br', runnerUp:'Italy',         ruIso:'it', score:'4–1' },
  { year:1974, host:'West Germany',   hostIso:'de', winner:'West Germany', winIso:'de', runnerUp:'Netherlands',   ruIso:'nl', score:'2–1' },
  { year:1978, host:'Argentina',      hostIso:'ar', winner:'Argentina',    winIso:'ar', runnerUp:'Netherlands',   ruIso:'nl', score:'3–1 AET' },
  { year:1982, host:'Spain',          hostIso:'es', winner:'Italy',        winIso:'it', runnerUp:'West Germany',  ruIso:'de', score:'3–1' },
  { year:1986, host:'Mexico',         hostIso:'mx', winner:'Argentina',    winIso:'ar', runnerUp:'West Germany',  ruIso:'de', score:'3–2' },
  { year:1990, host:'Italy',          hostIso:'it', winner:'West Germany', winIso:'de', runnerUp:'Argentina',     ruIso:'ar', score:'1–0' },
  { year:1994, host:'USA',            hostIso:'us', winner:'Brazil',       winIso:'br', runnerUp:'Italy',         ruIso:'it', score:'0–0 (3–2 pens)' },
  { year:1998, host:'France',         hostIso:'fr', winner:'France',       winIso:'fr', runnerUp:'Brazil',        ruIso:'br', score:'3–0' },
  { year:2002, host:'South Korea & Japan', hostIso:'jp', winner:'Brazil',  winIso:'br', runnerUp:'Germany',       ruIso:'de', score:'2–0' },
  { year:2006, host:'Germany',        hostIso:'de', winner:'Italy',        winIso:'it', runnerUp:'France',        ruIso:'fr', score:'1–1 (5–3 pens)' },
  { year:2010, host:'South Africa',   hostIso:'za', winner:'Spain',        winIso:'es', runnerUp:'Netherlands',   ruIso:'nl', score:'1–0 AET' },
  { year:2014, host:'Brazil',         hostIso:'br', winner:'Germany',      winIso:'de', runnerUp:'Argentina',     ruIso:'ar', score:'1–0 AET' },
  { year:2018, host:'Russia',         hostIso:'ru', winner:'France',       winIso:'fr', runnerUp:'Croatia',       ruIso:'hr', score:'4–2' },
  { year:2022, host:'Qatar',          hostIso:'qa', winner:'Argentina',    winIso:'ar', runnerUp:'France',        ruIso:'fr', score:'3–3 (4–2 pens)' },
  { year:2026, host:'USA / Canada / Mexico', hostIso:'us', winner:'TBD',  winIso:null, runnerUp:'TBD',           ruIso:null, score:'July 19, MetLife Stadium' },
  { year:2030, host:'Morocco / Spain / Portugal + centenary matches', hostIso:'ma', winner:'—', winIso:null, runnerUp:'—', ruIso:null, score:'Upcoming' },
  { year:2034, host:'Saudi Arabia',   hostIso:'sa', winner:'—',            winIso:null, runnerUp:'—',             ruIso:null, score:'Upcoming' },
];

// ─── Prize Money ─────────────────────────────────────────────────────────────
const PRIZE_MONEY = [
  { stage:'🏆 Champions',          amount:50000000, teams:1 },
  { stage:'🥈 Runners-up',         amount:35000000, teams:1 },
  { stage:'🥉 3rd Place',          amount:30000000, teams:1 },
  { stage:'4th Place',             amount:27000000, teams:1 },
  { stage:'Quarter-final exits',   amount:25000000, teams:4 },
  { stage:'Round of 16 exits',     amount:20000000, teams:8 },
  { stage:'Round of 32 exits',     amount:16000000, teams:16 },
  { stage:'Group stage exits',     amount:12500000, teams:16 },
];

// ─── Regional Cups ────────────────────────────────────────────────────────────
const REGIONAL_CUPS = [
  { tournament:'UEFA Euro 2024',      winner:'Spain',         iso:'es',     final:'Spain 2–1 England',        date:'July 14, 2024',     venue:'Olympiastadion, Berlin' },
  { tournament:'Copa América 2024',   winner:'Argentina',     iso:'ar',     final:'Argentina 1–0 Colombia',   date:'July 14, 2024',     venue:'Hard Rock Stadium, Miami' },
  { tournament:'AFCON 2024',          winner:"Côte d'Ivoire", iso:'ci',     final:"Côte d'Ivoire 2–1 Nigeria",date:'Feb 11, 2024',      venue:'Stade Alassane Ouattara, Abidjan' },
  { tournament:'AFC Asian Cup 2023',  winner:'Qatar',         iso:'qa',     final:'Qatar 3–1 Jordan',         date:'Feb 10, 2024',      venue:'Lusail Stadium, Qatar' },
  { tournament:'CONCACAF Gold Cup 2023',winner:'Mexico',      iso:'mx',     final:'Mexico 1–0 Panama',        date:'July 16, 2023',     venue:'SoFi Stadium, Los Angeles' },
  { tournament:'OFC Nations Cup 2024',winner:'New Zealand',   iso:'nz',     final:'New Zealand qualified as OFC rep', date:'2024',     venue:'Oceania' },
];

// ─── Nation History ───────────────────────────────────────────────────────────
const NATION_HISTORY = {
  USA: [
    { year:1930, stage:'Semi-final',    result:'W2 L1', notes:'Finished 3rd overall — beat Belgium 3-0 & Paraguay 3-0; lost to Argentina 6-1' },
    { year:1934, stage:'Round of 16',   result:'L1',    notes:'Lost to Italy 7-1' },
    { year:1950, stage:'Group stage',   result:'W1 L2', notes:'Historic 1-0 win over England — one of the biggest upsets ever' },
    { year:1990, stage:'Group stage',   result:'D1 L2', notes:'First WC after 40-year absence' },
    { year:1994, stage:'Round of 16',   result:'W2 D1 L1', notes:'Host nation; lost to Brazil 0-1' },
    { year:1998, stage:'Group stage',   result:'D1 L2', notes:'0 wins, eliminated early' },
    { year:2002, stage:'Quarter-final', result:'W3 L1', notes:'Best modern result — beat Portugal & Mexico; lost to Germany 0-1' },
    { year:2006, stage:'Group stage',   result:'D2 L1', notes:'No wins, 1 point' },
    { year:2010, stage:'Round of 16',   result:'W1 D2 L1', notes:'Topped group; lost to Ghana 1-2 AET' },
    { year:2014, stage:'Round of 16',   result:'W2 L2', notes:'Lost to Belgium 1-2 AET' },
    { year:2018, stage:'Did not qualify', result:'—',   notes:'Shocking CONCACAF failure; lost home qualifier to Trinidad & Tobago' },
    { year:2022, stage:'Round of 16',   result:'W1 D2 L1', notes:'Lost to Netherlands 1-3' },
    { year:2026, stage:'Host Nation',   result:'TBD',  notes:'Group D: vs Paraguay, Australia, Türkiye' },
  ],
  Mexico: [
    { year:1930, stage:'Group stage',   result:'W0 L3', notes:'Conceded 13 goals in 3 games' },
    { year:1950, stage:'Group stage',   result:'W0 L3', notes:'Lost to Brazil, Yugoslavia, Switzerland' },
    { year:1954, stage:'Group stage',   result:'W0 L2', notes:'Outscored 10-3' },
    { year:1958, stage:'Group stage',   result:'W0 L3', notes:'Third group stage exit in a row' },
    { year:1962, stage:'Group stage',   result:'W0 D1 L2', notes:'First ever WC draw' },
    { year:1966, stage:'Group stage',   result:'W1 D0 L2', notes:'First ever WC win — beat France 1-0' },
    { year:1970, stage:'Quarter-final', result:'W2 L1', notes:'Host nation; lost to Italy 1-4' },
    { year:1974, stage:'Group stage',   result:'W0 D1 L2', notes:'' },
    { year:1978, stage:'Group stage',   result:'W1 D1 L1', notes:'' },
    { year:1982, stage:'Group stage',   result:'W1 D1 L1', notes:'' },
    { year:1986, stage:'Quarter-final', result:'W3 L1', notes:'Host nation; lost to West Germany on penalties. Last time they advanced beyond R16.' },
    { year:1990, stage:'Suspended',     result:'—',    notes:'Banned by FIFA for fielding over-age players in youth tournament' },
    { year:1994, stage:'Round of 16',   result:'W1 D2 L1', notes:'Lost to Bulgaria on penalties — "quinto partido" curse begins' },
    { year:1998, stage:'Round of 16',   result:'W2 D0 L1', notes:'Lost to Germany 1-2' },
    { year:2002, stage:'Round of 16',   result:'W2 D0 L1', notes:'Lost to USA 0-2' },
    { year:2006, stage:'Round of 16',   result:'W1 D1 L1', notes:'Lost to Argentina 1-2 AET' },
    { year:2010, stage:'Round of 16',   result:'W1 D1 L1', notes:'Lost to Argentina 1-3' },
    { year:2014, stage:'Round of 16',   result:'W2 D0 L1', notes:'Lost to Argentina 1-2' },
    { year:2018, stage:'Round of 16',   result:'W2 D0 L1', notes:'Lost to Brazil 0-2 — 7th consecutive R16 exit' },
    { year:2022, stage:'Group stage',   result:'W1 D1 L1', notes:'First group stage exit since 1978 — failed the "quinto partido" to reach' },
    { year:2026, stage:'Host Nation',   result:'TBD',  notes:'Group A: vs South Africa, South Korea, Czechia. Opening match June 11.' },
  ],
  Lithuania: {
    neverQualified: true,
    confederation: 'UEFA',
    note: 'Lithuania has never qualified for a FIFA World Cup. They compete in UEFA European qualifying where they have consistently been drawn in difficult groups against higher-ranked opponents. Their best qualifying campaign came in the late 1990s under Benjaminas Zelkevičius, finishing 3rd in their group. As of April 2026, Lithuania is ranked outside the top 130 in the FIFA world rankings. In UEFA Nations League they compete in League C/D. The 2026 qualifying campaign saw them finish last in UEFA Group G behind the Netherlands, Poland, Finland, and Malta.',
  },
};

// ─── Schedule (Group Stage, all 72 matches) ───────────────────────────────────
const CITIES = ['Atlanta','Boston','Dallas','Guadalajara','Houston','Kansas City','Los Angeles','Mexico City','Miami','Monterrey','New Jersey','Philadelphia','Santa Clara','Seattle','Toronto','Vancouver'];
const DATES   = ['Jun 11','Jun 12','Jun 13','Jun 14','Jun 15','Jun 16','Jun 17','Jun 18','Jun 19','Jun 20','Jun 21','Jun 22','Jun 23','Jun 24','Jun 25','Jun 26','Jun 27'];
const KNOCKOUT_DATES = ['Jun 28','Jun 29','Jun 30','Jul 1','Jul 2','Jul 3','Jul 4','Jul 5','Jul 6','Jul 7','Jul 9','Jul 10','Jul 11','Jul 14','Jul 15','Jul 18','Jul 19'];
const KNOCKOUT_COLOR = { 'Round of 32':'#2d3748', 'Round of 16':'#3182ce', 'Quarterfinal':'#dd6b20', 'Semifinal':'#e53e3e', '🏆 Final':'#f0b429', '🥉 3rd Place':'#cd7f32' };
const KNOCKOUTS_RAW = [
  // Round of 32 (Jun 28 – Jul 3)
  { date:'Jun 28', city:'Los Angeles',  round:'Round of 32' },
  { date:'Jun 29', city:'Houston',      round:'Round of 32' },
  { date:'Jun 29', city:'Boston',       round:'Round of 32' },
  { date:'Jun 29', city:'Monterrey',    round:'Round of 32' },
  { date:'Jun 30', city:'Dallas',       round:'Round of 32' },
  { date:'Jun 30', city:'New Jersey',   round:'Round of 32' },
  { date:'Jun 30', city:'Mexico City',  round:'Round of 32' },
  { date:'Jul 1',  city:'Atlanta',      round:'Round of 32' },
  { date:'Jul 1',  city:'Seattle',      round:'Round of 32' },
  { date:'Jul 1',  city:'Santa Clara',  round:'Round of 32' },
  { date:'Jul 2',  city:'Los Angeles',  round:'Round of 32' },
  { date:'Jul 2',  city:'Toronto',      round:'Round of 32' },
  { date:'Jul 2',  city:'Vancouver',    round:'Round of 32' },
  { date:'Jul 3',  city:'Dallas',       round:'Round of 32' },
  { date:'Jul 3',  city:'Miami',        round:'Round of 32' },
  { date:'Jul 3',  city:'Kansas City',  round:'Round of 32' },
  // Round of 16 (Jul 4–7)
  { date:'Jul 4',  city:'Houston',      round:'Round of 16' },
  { date:'Jul 4',  city:'Philadelphia', round:'Round of 16' },
  { date:'Jul 5',  city:'New Jersey',   round:'Round of 16' },
  { date:'Jul 5',  city:'Mexico City',  round:'Round of 16' },
  { date:'Jul 6',  city:'Dallas',       round:'Round of 16' },
  { date:'Jul 6',  city:'Seattle',      round:'Round of 16' },
  { date:'Jul 7',  city:'Atlanta',      round:'Round of 16' },
  { date:'Jul 7',  city:'Vancouver',    round:'Round of 16' },
  // Quarterfinals (Jul 9–11)
  { date:'Jul 9',  city:'Boston',       round:'Quarterfinal' },
  { date:'Jul 10', city:'Los Angeles',  round:'Quarterfinal' },
  { date:'Jul 11', city:'Miami',        round:'Quarterfinal' },
  { date:'Jul 11', city:'Kansas City',  round:'Quarterfinal' },
  // Semifinals (Jul 14–15)
  { date:'Jul 14', city:'Dallas',       round:'Semifinal' },
  { date:'Jul 15', city:'Atlanta',      round:'Semifinal' },
  // 3rd Place & Final
  { date:'Jul 18', city:'Miami',        round:'🥉 3rd Place' },
  { date:'Jul 19', city:'New Jersey',   round:'🏆 Final' },
];

const MATCHES_RAW = [
  { date:'Jun 11', city:'Mexico City', time:'3:00 PM',  grp:'A', t1:'Mexico',          t2:'South Africa'     },
  { date:'Jun 11', city:'Guadalajara', time:'10:00 PM', grp:'A', t1:'South Korea',      t2:'Czechia'          },
  { date:'Jun 12', city:'Toronto',     time:'3:00 PM',  grp:'B', t1:'Canada',           t2:'Bosnia & Herz.'   },
  { date:'Jun 12', city:'Los Angeles', time:'9:00 PM',  grp:'D', t1:'USA',              t2:'Paraguay'         },
  { date:'Jun 13', city:'Santa Clara', time:'3:00 PM',  grp:'B', t1:'Qatar',            t2:'Switzerland'      },
  { date:'Jun 13', city:'New Jersey',  time:'6:00 PM',  grp:'C', t1:'Brazil',           t2:'Morocco'          },
  { date:'Jun 13', city:'Boston',      time:'9:00 PM',  grp:'C', t1:'Haiti',            t2:'Scotland'         },
  { date:'Jun 14', city:'Vancouver',   time:'12:00 AM', grp:'D', t1:'Australia',        t2:'Türkiye'          },
  { date:'Jun 14', city:'Houston',     time:'1:00 PM',  grp:'E', t1:'Germany',          t2:'Curaçao'          },
  { date:'Jun 14', city:'Dallas',      time:'4:00 PM',  grp:'F', t1:'Netherlands',      t2:'Japan'            },
  { date:'Jun 14', city:'Philadelphia',time:'7:00 PM',  grp:'E', t1:"Côte d'Ivoire",    t2:'Ecuador'          },
  { date:'Jun 14', city:'Monterrey',   time:'10:00 PM', grp:'F', t1:'Sweden',           t2:'Tunisia'          },
  { date:'Jun 15', city:'Atlanta',     time:'12:00 PM', grp:'H', t1:'Spain',            t2:'Cape Verde'       },
  { date:'Jun 15', city:'Seattle',     time:'3:00 PM',  grp:'G', t1:'Belgium',          t2:'Egypt'            },
  { date:'Jun 15', city:'Miami',       time:'6:00 PM',  grp:'H', t1:'Saudi Arabia',     t2:'Uruguay'          },
  { date:'Jun 15', city:'Los Angeles', time:'9:00 PM',  grp:'G', t1:'Iran',             t2:'New Zealand'      },
  { date:'Jun 16', city:'New Jersey',  time:'3:00 PM',  grp:'I', t1:'France',           t2:'Senegal'          },
  { date:'Jun 16', city:'Boston',      time:'6:00 PM',  grp:'I', t1:'Iraq',             t2:'Norway'           },
  { date:'Jun 16', city:'Kansas City', time:'9:00 PM',  grp:'J', t1:'Argentina',        t2:'Algeria'          },
  { date:'Jun 17', city:'Santa Clara', time:'12:00 AM', grp:'J', t1:'Austria',          t2:'Jordan'           },
  { date:'Jun 17', city:'Houston',     time:'1:00 PM',  grp:'K', t1:'Portugal',         t2:'DR Congo'         },
  { date:'Jun 17', city:'Dallas',      time:'4:00 PM',  grp:'L', t1:'England',          t2:'Croatia'          },
  { date:'Jun 17', city:'Toronto',     time:'7:00 PM',  grp:'L', t1:'Ghana',            t2:'Panama'           },
  { date:'Jun 17', city:'Mexico City', time:'10:00 PM', grp:'K', t1:'Uzbekistan',       t2:'Colombia'         },
  { date:'Jun 18', city:'Atlanta',     time:'12:00 PM', grp:'A', t1:'Czechia',          t2:'South Africa'     },
  { date:'Jun 18', city:'Los Angeles', time:'3:00 PM',  grp:'B', t1:'Switzerland',      t2:'Bosnia & Herz.'   },
  { date:'Jun 18', city:'Vancouver',   time:'6:00 PM',  grp:'B', t1:'Canada',           t2:'Qatar'            },
  { date:'Jun 18', city:'Guadalajara', time:'9:00 PM',  grp:'A', t1:'Mexico',           t2:'South Korea'      },
  { date:'Jun 19', city:'Seattle',     time:'3:00 PM',  grp:'D', t1:'USA',              t2:'Australia'        },
  { date:'Jun 19', city:'Boston',      time:'6:00 PM',  grp:'C', t1:'Scotland',         t2:'Morocco'          },
  { date:'Jun 19', city:'Philadelphia',time:'8:30 PM',  grp:'C', t1:'Brazil',           t2:'Haiti'            },
  { date:'Jun 19', city:'Santa Clara', time:'11:00 PM', grp:'D', t1:'Türkiye',          t2:'Paraguay'         },
  { date:'Jun 20', city:'Houston',     time:'1:00 PM',  grp:'F', t1:'Netherlands',      t2:'Sweden'           },
  { date:'Jun 20', city:'Toronto',     time:'4:00 PM',  grp:'E', t1:'Germany',          t2:"Côte d'Ivoire"    },
  { date:'Jun 20', city:'Kansas City', time:'8:00 PM',  grp:'E', t1:'Ecuador',          t2:'Curaçao'          },
  { date:'Jun 21', city:'Monterrey',   time:'12:00 AM', grp:'F', t1:'Tunisia',          t2:'Japan'            },
  { date:'Jun 21', city:'Atlanta',     time:'12:00 PM', grp:'H', t1:'Spain',            t2:'Saudi Arabia'     },
  { date:'Jun 21', city:'Los Angeles', time:'3:00 PM',  grp:'G', t1:'Belgium',          t2:'Iran'             },
  { date:'Jun 21', city:'Miami',       time:'6:00 PM',  grp:'H', t1:'Uruguay',          t2:'Cape Verde'       },
  { date:'Jun 21', city:'Vancouver',   time:'9:00 PM',  grp:'G', t1:'New Zealand',      t2:'Egypt'            },
  { date:'Jun 22', city:'Dallas',      time:'1:00 PM',  grp:'J', t1:'Argentina',        t2:'Austria'          },
  { date:'Jun 22', city:'Philadelphia',time:'5:00 PM',  grp:'I', t1:'France',           t2:'Iraq'             },
  { date:'Jun 22', city:'New Jersey',  time:'8:00 PM',  grp:'I', t1:'Norway',           t2:'Senegal'          },
  { date:'Jun 22', city:'Santa Clara', time:'11:00 PM', grp:'J', t1:'Jordan',           t2:'Algeria'          },
  { date:'Jun 23', city:'Houston',     time:'1:00 PM',  grp:'K', t1:'Portugal',         t2:'Uzbekistan'       },
  { date:'Jun 23', city:'Boston',      time:'4:00 PM',  grp:'L', t1:'England',          t2:'Ghana'            },
  { date:'Jun 23', city:'Toronto',     time:'7:00 PM',  grp:'L', t1:'Panama',           t2:'Croatia'          },
  { date:'Jun 23', city:'Guadalajara', time:'10:00 PM', grp:'K', t1:'Colombia',         t2:'DR Congo'         },
  { date:'Jun 24', city:'Vancouver',   time:'3:00 PM',  grp:'B', t1:'Switzerland',      t2:'Canada'           },
  { date:'Jun 24', city:'Seattle',     time:'3:00 PM',  grp:'B', t1:'Bosnia & Herz.',   t2:'Qatar'            },
  { date:'Jun 24', city:'Miami',       time:'6:00 PM',  grp:'C', t1:'Scotland',         t2:'Brazil'           },
  { date:'Jun 24', city:'Atlanta',     time:'6:00 PM',  grp:'C', t1:'Morocco',          t2:'Haiti'            },
  { date:'Jun 24', city:'Mexico City', time:'9:00 PM',  grp:'A', t1:'Czechia',          t2:'Mexico'           },
  { date:'Jun 24', city:'Monterrey',   time:'9:00 PM',  grp:'A', t1:'South Africa',     t2:'South Korea'      },
  { date:'Jun 25', city:'Philadelphia',time:'4:00 PM',  grp:'E', t1:'Curaçao',          t2:"Côte d'Ivoire"    },
  { date:'Jun 25', city:'New Jersey',  time:'4:00 PM',  grp:'E', t1:'Ecuador',          t2:'Germany'          },
  { date:'Jun 25', city:'Dallas',      time:'7:00 PM',  grp:'F', t1:'Japan',            t2:'Sweden'           },
  { date:'Jun 25', city:'Kansas City', time:'7:00 PM',  grp:'F', t1:'Tunisia',          t2:'Netherlands'      },
  { date:'Jun 25', city:'Los Angeles', time:'10:00 PM', grp:'D', t1:'Türkiye',          t2:'USA'              },
  { date:'Jun 25', city:'Santa Clara', time:'10:00 PM', grp:'D', t1:'Paraguay',         t2:'Australia'        },
  { date:'Jun 26', city:'Boston',      time:'3:00 PM',  grp:'I', t1:'Norway',           t2:'France'           },
  { date:'Jun 26', city:'Toronto',     time:'3:00 PM',  grp:'I', t1:'Senegal',          t2:'Iraq'             },
  { date:'Jun 26', city:'Houston',     time:'8:00 PM',  grp:'H', t1:'Cape Verde',       t2:'Saudi Arabia'     },
  { date:'Jun 26', city:'Guadalajara', time:'8:00 PM',  grp:'H', t1:'Uruguay',          t2:'Spain'            },
  { date:'Jun 26', city:'Seattle',     time:'11:00 PM', grp:'G', t1:'Egypt',            t2:'Iran'             },
  { date:'Jun 26', city:'Vancouver',   time:'11:00 PM', grp:'G', t1:'New Zealand',      t2:'Belgium'          },
  { date:'Jun 27', city:'New Jersey',  time:'5:00 PM',  grp:'L', t1:'Panama',           t2:'England'          },
  { date:'Jun 27', city:'Philadelphia',time:'5:00 PM',  grp:'L', t1:'Croatia',          t2:'Ghana'            },
  { date:'Jun 27', city:'Miami',       time:'7:30 PM',  grp:'K', t1:'Colombia',         t2:'Portugal'         },
  { date:'Jun 27', city:'Atlanta',     time:'7:30 PM',  grp:'K', t1:'DR Congo',         t2:'Uzbekistan'       },
  { date:'Jun 27', city:'Kansas City', time:'10:00 PM', grp:'J', t1:'Algeria',          t2:'Austria'          },
  { date:'Jun 27', city:'Dallas',      time:'10:00 PM', grp:'J', t1:'Jordan',           t2:'Argentina'        },
];

// ═══════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════
const GRP_COLOR = { A:'#7c3aed',B:'#2563eb',C:'#059669',D:'#d97706',E:'#dc2626',F:'#0891b2',G:'#7c3aed',H:'#be185d',I:'#1d4ed8',J:'#15803d',K:'#b45309',L:'#6d28d9' };

function Flag({ iso, size='1em' }) {
  if (!iso) return <span style={{ width: size, display:'inline-block' }}/>;
  return <span className={`fi fi-${iso}`} style={{ fontSize: size, verticalAlign:'middle', flexShrink:0 }} />;
}

function impliedProb(americanOdds) {
  const p = americanOdds > 0 ? 100 / (americanOdds + 100) : (-americanOdds) / (-americanOdds + 100);
  return (p * 100).toFixed(1);
}

function fmtMoney(n) {
  if (n >= 1_000_000) return `$${(n/1_000_000).toFixed(1)}M`;
  return `$${n.toLocaleString()}`;
}

const POS_COLOR = { GK:'#0369a1', DEF:'#065f46', MID:'#7c3aed', FWD:'#dc2626' };

// ═══════════════════════════════════════════════
// SECTION COMPONENTS
// ═══════════════════════════════════════════════

function Rankings() {
  const [showAll, setShowAll] = useState(false);
  const rows = showAll ? FIFA_RANKINGS : FIFA_RANKINGS.slice(0, 25);
  const medals = { 1:'🥇', 2:'🥈', 3:'🥉' };
  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'0.75rem', flexWrap:'wrap', gap:'0.5rem' }}>
        <p style={{ color:'var(--text-muted)', fontSize:'0.82rem', margin:0 }}>Official FIFA Men's World Ranking · June 5, 2026 · <span style={{ color:'var(--gold)' }}>⚽ = qualified for WC2026</span></p>
      </div>
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ background:'rgba(255,255,255,0.04)', borderBottom:'1px solid var(--border)' }}>
              <th style={{ padding:'0.5rem 0.75rem', textAlign:'left', fontSize:'0.7rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em', width:44 }}>#</th>
              <th style={{ padding:'0.5rem 0.5rem', textAlign:'left', fontSize:'0.7rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em' }}>Country</th>
              <th style={{ padding:'0.5rem 0.75rem', textAlign:'right', fontSize:'0.7rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em' }}>Points</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.rank} style={{ borderBottom: i < rows.length-1 ? '1px solid var(--border)' : 'none', background: r.rank<=3 ? 'rgba(240,180,41,0.05)' : 'transparent', opacity: r.wc ? 1 : 0.38 }}>
                <td style={{ padding:'0.55rem 0.75rem' }}>
                  <span style={{ fontWeight:800, fontSize: r.rank<=3 ? '0.95rem':'0.82rem', color: r.rank<=3 ? 'var(--gold)':'var(--text-muted)' }}>{medals[r.rank] || r.rank}</span>
                </td>
                <td style={{ padding:'0.55rem 0.5rem' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'0.5rem' }}>
                    <Flag iso={r.iso} size="1em" />
                    <span style={{ fontSize:'0.85rem', fontWeight: r.wc ? 600 : 400 }}>{r.country}</span>
                    {r.wc && <span style={{ fontSize:'0.6rem', color:'var(--gold)' }}>⚽</span>}
                    {r.banned && <span style={{ fontSize:'0.6rem', background:'rgba(239,68,68,0.15)', color:'#ef4444', padding:'0.1rem 0.35rem', borderRadius:8, fontWeight:700 }}>BANNED</span>}
                  </div>
                </td>
                <td style={{ padding:'0.55rem 0.75rem', textAlign:'right', fontSize:'0.82rem', fontWeight:600, color: r.rank<=3 ? 'var(--gold)':'var(--text)', fontVariantNumeric:'tabular-nums' }}>{r.pts.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!showAll && <div style={{ textAlign:'center', marginTop:'0.75rem' }}><button className="btn btn-primary btn-sm" onClick={() => setShowAll(true)}>Show full top 50</button></div>}
      <div className="card mt-3" style={{ background:'rgba(240,180,41,0.06)', border:'1px solid rgba(240,180,41,0.25)', fontSize:'0.83rem', lineHeight:1.6 }}>
        <span style={{ color:'var(--gold)', fontWeight:700 }}>🔥 </span>France, Spain, and Argentina are separated by just <strong>2.50 FIFA points</strong> — the tightest top-3 in rankings history heading into a World Cup.
      </div>
    </div>
  );
}

function FunFactsTab() {
  const CATEGORY_COLORS = { Scale:'#7c3aed', Format:'#2563eb', 'Prize Money':'#b45309', Hosting:'#065f46', Rankings:'#1d4ed8', Absences:'#9f1239', Players:'#0369a1', Viewership:'#6d28d9', Debutants:'#0f766e', Stadiums:'#1a3550', History:'#92400e' };
  return (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:'1rem' }}>
      {FACTS.map((f, i) => (
        <div key={i} className="card" style={{ display:'flex', gap:'0.75rem' }}>
          <span style={{ fontSize:'1.7rem', lineHeight:1, flexShrink:0 }}>{f.icon}</span>
          <div>
            <span style={{ fontSize:'0.62rem', fontWeight:800, textTransform:'uppercase', letterSpacing:'0.07em', background: CATEGORY_COLORS[f.category]||'#1a3550', color:'#fff', padding:'0.12rem 0.45rem', borderRadius:10 }}>{f.category}</span>
            <h3 style={{ fontSize:'0.92rem', fontWeight:800, margin:'0.3rem 0 0.3rem' }}>{f.title}</h3>
            <p style={{ fontSize:'0.82rem', color:'var(--text-muted)', lineHeight:1.6, margin:0 }}>{f.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

function SquadsTab() {
  const [active, setActive] = useState('USA');
  const [filter, setFilter] = useState('ALL');
  const squad = SQUADS[active];
  const players = filter === 'ALL' ? squad.players : squad.players.filter(p => p.pos === filter);
  return (
    <div>
      <div className="bracket-tabs" style={{ marginBottom:'1rem' }}>
        {Object.keys(SQUADS).map(n => (
          <button key={n} className={`bracket-tab ${active===n?'active':''}`} onClick={() => { setActive(n); setFilter('ALL'); }}>
            <Flag iso={SQUADS[n].flag} size="0.9em" /> {n}
          </button>
        ))}
      </div>
      <div className="card" style={{ marginBottom:'1rem', padding:'0.85rem 1rem' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', flexWrap:'wrap' }}>
          <Flag iso={squad.flag} size="1.6em" />
          <div>
            <div style={{ fontWeight:800, fontSize:'1rem' }}>{active}</div>
            <div style={{ fontSize:'0.78rem', color:'var(--text-muted)' }}>Coach: {squad.coach} · Group {squad.group}</div>
          </div>
          <div style={{ marginLeft:'auto', fontSize:'0.72rem', color:'rgba(240,180,41,0.8)', background:'rgba(240,180,41,0.08)', border:'1px solid rgba(240,180,41,0.2)', padding:'0.25rem 0.6rem', borderRadius:8 }}>
            {squad.note}
          </div>
        </div>
      </div>
      <div style={{ display:'flex', gap:'0.5rem', marginBottom:'1rem', flexWrap:'wrap' }}>
        {['ALL','GK','DEF','MID','FWD'].map(p => (
          <button key={p} onClick={() => setFilter(p)} style={{ fontSize:'0.72rem', fontWeight:700, padding:'0.2rem 0.7rem', borderRadius:20, border:`1px solid ${filter===p ? POS_COLOR[p]||'var(--gold)' : 'var(--border)'}`, background: filter===p ? (POS_COLOR[p]||'var(--gold)')+'22' : 'transparent', color: filter===p ? (POS_COLOR[p]||'var(--gold)') : 'var(--text-muted)', cursor:'pointer' }}>{p}</button>
        ))}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))', gap:'0.5rem' }}>
        {players.map((p, i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', gap:'0.6rem', background:'var(--navy-light)', borderRadius:8, padding:'0.5rem 0.75rem', border:'1px solid var(--border)' }}>
            <span style={{ fontSize:'0.65rem', fontWeight:800, color:'#fff', background: POS_COLOR[p.pos]||'#555', padding:'0.15rem 0.4rem', borderRadius:6, minWidth:30, textAlign:'center' }}>{p.pos}</span>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:'0.83rem', fontWeight:700 }}>{p.name}{p.captain ? ' 🅒' : ''}</div>
              <div style={{ fontSize:'0.72rem', color:'var(--text-muted)' }}>{p.club} · {p.age}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function OddsTab() {
  return (
    <div>
      <div className="card" style={{ background:'rgba(240,180,41,0.06)', border:'1px solid rgba(240,180,41,0.2)', marginBottom:'1rem', fontSize:'0.82rem', lineHeight:1.6 }}>
        <span style={{ color:'var(--gold)', fontWeight:700 }}>📖 How to read: </span>"+500" means a $100 bet wins $500 profit. Implied probability = the bookmaker's estimated chance of winning. Source: DraftKings / ESPN, June 2026. Odds shift daily as group play continues.
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(230px,1fr))', gap:'0.5rem' }}>
        {ODDS.map((o, i) => {
          const prob = parseFloat(impliedProb(o.odds));
          const isTop = i < 8;
          return (
            <div key={o.country} style={{ display:'flex', alignItems:'center', gap:'0.6rem', background: isTop ? 'rgba(240,180,41,0.06)':'var(--navy-light)', borderRadius:8, padding:'0.55rem 0.75rem', border:`1px solid ${isTop ? 'rgba(240,180,41,0.25)':'var(--border)'}` }}>
              <span style={{ fontSize:'0.72rem', fontWeight:800, color:'var(--text-muted)', minWidth:20, textAlign:'right' }}>#{i+1}</span>
              <Flag iso={o.iso} size="1em" />
              <div style={{ flex:1 }}>
                <div style={{ fontSize:'0.83rem', fontWeight:600 }}>{o.country}</div>
                <div style={{ fontSize:'0.7rem', color:'var(--text-muted)' }}>{prob}% chance</div>
              </div>
              <span style={{ fontSize:'0.82rem', fontWeight:800, color: isTop ? 'var(--gold)':'var(--text)', whiteSpace:'nowrap' }}>+{o.odds.toLocaleString()}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ConfederationsTab() {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'1.5rem' }}>
      {CONFEDERATIONS.map(conf => (
        <div key={conf.name}>
          <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'0.75rem' }}>
            <div style={{ width:10, height:10, borderRadius:'50%', background:conf.color }} />
            <h3 style={{ margin:0, fontSize:'1rem', fontWeight:800 }}>{conf.name}</h3>
            <span style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>{conf.region}</span>
            <span style={{ marginLeft:'auto', fontSize:'0.72rem', fontWeight:700, color:conf.color, background:conf.color+'22', padding:'0.15rem 0.5rem', borderRadius:10 }}>{conf.teams.length} teams</span>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:'0.4rem' }}>
            {conf.teams.map(t => (
              <div key={t.name} style={{ display:'flex', alignItems:'center', gap:'0.5rem', background:'var(--navy-light)', borderRadius:7, padding:'0.4rem 0.65rem', border:'1px solid var(--border)' }}>
                <Flag iso={t.iso} size="1em" />
                <span style={{ fontSize:'0.82rem', flex:1 }}>{t.name}{t.host ? ' 🏠':''}</span>
                <span style={{ fontSize:'0.65rem', fontWeight:800, color:'#fff', background: GRP_COLOR[t.group]||'#333', padding:'0.12rem 0.4rem', borderRadius:5 }}>Grp {t.group}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function HistoryTab() {
  return (
    <div>
      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ background:'rgba(255,255,255,0.04)', borderBottom:'1px solid var(--border)' }}>
              {['Year','Host','Winner','Runner-up','Final Score'].map(h => (
                <th key={h} style={{ padding:'0.5rem 0.75rem', textAlign:'left', fontSize:'0.68rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {WC_HISTORY.map((r, i) => {
              const isCurrent = r.year === 2026;
              const isFuture  = r.year > 2026;
              return (
                <tr key={r.year} style={{ borderBottom: i < WC_HISTORY.length-1 ? '1px solid var(--border)':'none', background: isCurrent ? 'rgba(240,180,41,0.07)' : isFuture ? 'rgba(255,255,255,0.02)' : 'transparent', opacity: isFuture ? 0.6 : 1 }}>
                  <td style={{ padding:'0.5rem 0.75rem', fontWeight:800, color: isCurrent ? 'var(--gold)':'var(--text)', fontSize:'0.85rem' }}>{r.year}</td>
                  <td style={{ padding:'0.5rem 0.75rem' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'0.4rem', fontSize:'0.82rem' }}>
                      <Flag iso={r.hostIso} size="0.9em" /> {r.host}
                    </div>
                  </td>
                  <td style={{ padding:'0.5rem 0.75rem' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'0.4rem', fontSize:'0.82rem', fontWeight: r.winIso ? 600 : 400 }}>
                      {r.winIso && <Flag iso={r.winIso} size="0.9em" />} {r.winner}
                    </div>
                  </td>
                  <td style={{ padding:'0.5rem 0.75rem' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'0.4rem', fontSize:'0.82rem', color:'var(--text-muted)' }}>
                      {r.ruIso && <Flag iso={r.ruIso} size="0.9em" />} {r.runnerUp}
                    </div>
                  </td>
                  <td style={{ padding:'0.5rem 0.75rem', fontSize:'0.8rem', color:'var(--text-muted)' }}>{r.score}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function PrizeMoneyTab() {
  const total = 871000000;
  return (
    <div>
      <div style={{ textAlign:'center', background:'linear-gradient(135deg,#0a1628,#1a2f55)', borderRadius:12, padding:'1.5rem', marginBottom:'1.5rem', border:'1px solid var(--border)' }}>
        <div style={{ fontSize:'2.5rem', fontWeight:900, color:'var(--gold)' }}>$871M</div>
        <div style={{ color:'var(--text-muted)', fontSize:'0.9rem' }}>Total FIFA World Cup 2026 Prize Pool</div>
        <div style={{ fontSize:'0.78rem', color:'var(--text-muted)', marginTop:'0.3rem' }}>Largest in World Cup history — a 107% increase from the $440M awarded in Qatar 2022</div>
      </div>
      <div style={{ display:'flex', flexDirection:'column', gap:'0.5rem' }}>
        {PRIZE_MONEY.map((p, i) => {
          const pct = (p.amount / total) * 100;
          return (
            <div key={i} className="card" style={{ padding:'0.85rem 1rem' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'0.4rem' }}>
                <span style={{ fontSize:'0.88rem', fontWeight:700 }}>{p.stage}</span>
                <div style={{ textAlign:'right' }}>
                  <span style={{ fontSize:'0.95rem', fontWeight:900, color:'var(--gold)' }}>{fmtMoney(p.amount)}</span>
                  {p.teams > 1 && <span style={{ fontSize:'0.72rem', color:'var(--text-muted)', marginLeft:'0.4rem' }}>× {p.teams} teams = {fmtMoney(p.amount * p.teams)}</span>}
                </div>
              </div>
              <div style={{ height:5, background:'var(--border)', borderRadius:3 }}>
                <div style={{ height:'100%', width:`${pct}%`, background:'linear-gradient(90deg,var(--gold-dark),var(--gold))', borderRadius:3 }} />
              </div>
            </div>
          );
        })}
      </div>
      <div className="card mt-2" style={{ fontSize:'0.82rem', color:'var(--text-muted)', lineHeight:1.6 }}>
        💡 Every one of the 48 teams is <strong style={{ color:'var(--text)' }}>guaranteed $12.5M</strong> just for qualifying — the highest floor payment in World Cup history. Even the first-round exit of Haiti walks away with more prize money than the 2010 champion Spain earned in total from their title run.
      </div>
    </div>
  );
}

function RegionalCupsTab() {
  return (
    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:'1rem' }}>
      {REGIONAL_CUPS.map((c, i) => (
        <div key={i} className="card">
          <div style={{ fontSize:'0.68rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:'0.5rem' }}>{c.date}</div>
          <div style={{ fontSize:'0.78rem', fontWeight:700, color:'var(--text-muted)', marginBottom:'0.35rem' }}>{c.tournament}</div>
          <div style={{ display:'flex', alignItems:'center', gap:'0.6rem', marginBottom:'0.5rem' }}>
            <Flag iso={c.iso} size="1.6em" />
            <span style={{ fontSize:'1.05rem', fontWeight:900, color:'var(--gold)' }}>{c.winner}</span>
          </div>
          <div style={{ fontSize:'0.8rem', color:'var(--text)', fontWeight:600, marginBottom:'0.25rem' }}>{c.final}</div>
          <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>📍 {c.venue}</div>
        </div>
      ))}
    </div>
  );
}

function NationHistoryTab() {
  const [nation, setNation] = useState('USA');
  return (
    <div>
      <div className="bracket-tabs" style={{ marginBottom:'1rem' }}>
        {['USA','Mexico','Lithuania'].map(n => (
          <button key={n} className={`bracket-tab ${nation===n?'active':''}`} onClick={() => setNation(n)}>{n}</button>
        ))}
      </div>

      {nation === 'Lithuania' ? (
        <div>
          <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'1rem' }}>
            <Flag iso="lt" size="2em" />
            <div>
              <div style={{ fontWeight:800, fontSize:'1.1rem' }}>Lithuania</div>
              <div style={{ fontSize:'0.8rem', color:'var(--text-muted)' }}>UEFA · Never qualified for the FIFA World Cup</div>
            </div>
          </div>
          <div className="card" style={{ background:'rgba(239,68,68,0.06)', border:'1px solid rgba(239,68,68,0.2)' }}>
            <div style={{ fontSize:'2rem', marginBottom:'0.5rem' }}>🚫</div>
            <h3 style={{ fontWeight:800, marginBottom:'0.5rem' }}>Lithuania has never qualified for a FIFA World Cup</h3>
            <p style={{ fontSize:'0.85rem', color:'var(--text-muted)', lineHeight:1.7, margin:0 }}>{NATION_HISTORY.Lithuania.note}</p>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ display:'flex', alignItems:'center', gap:'0.75rem', marginBottom:'1rem' }}>
            <Flag iso={nation==='USA'?'us':'mx'} size="2em" />
            <div>
              <div style={{ fontWeight:800, fontSize:'1.1rem' }}>{nation}</div>
              <div style={{ fontSize:'0.8rem', color:'var(--text-muted)' }}>
                {nation==='USA' ? 'CONCACAF · Best result: Semi-finals (1930)' : 'CONCACAF · Best result: Quarter-finals (1970, 1986)'}
              </div>
            </div>
          </div>
          {nation === 'Mexico' && (
            <div className="card" style={{ background:'rgba(240,180,41,0.06)', border:'1px solid rgba(240,180,41,0.2)', marginBottom:'1rem', fontSize:'0.82rem', lineHeight:1.6 }}>
              <span style={{ color:'var(--gold)', fontWeight:700 }}>⚡ El Quinto Partido: </span>Mexico reached the Round of 16 in 8 consecutive World Cups (1994–2018) but never won that match. Fans call the elusive 5th match "el quinto partido" — the fifth game Mexico can never seem to reach.
            </div>
          )}
          <div className="card" style={{ padding:0, overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ background:'rgba(255,255,255,0.04)', borderBottom:'1px solid var(--border)' }}>
                  {['Year','Stage','Record','Notes'].map(h => (
                    <th key={h} style={{ padding:'0.45rem 0.75rem', textAlign:'left', fontSize:'0.68rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.05em' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {NATION_HISTORY[nation].map((r, i) => {
                  const isHost  = r.stage === 'Host Nation';
                  const isBest  = r.stage.includes('Quarter') || r.stage.includes('Semi') || (nation==='USA' && r.stage.includes('Semi'));
                  const isDNQ   = r.stage.includes('not') || r.stage.includes('Suspended');
                  return (
                    <tr key={r.year} style={{ borderBottom: i < NATION_HISTORY[nation].length-1 ? '1px solid var(--border)':'none', background: isHost ? 'rgba(240,180,41,0.07)' : isBest ? 'rgba(34,197,94,0.05)' : isDNQ ? 'rgba(239,68,68,0.05)' : 'transparent' }}>
                      <td style={{ padding:'0.5rem 0.75rem', fontWeight:800, fontSize:'0.85rem', color: isHost ? 'var(--gold)' : 'var(--text)' }}>{r.year}</td>
                      <td style={{ padding:'0.5rem 0.75rem', fontSize:'0.82rem', fontWeight:600, color: isBest ? '#22c55e' : isDNQ ? '#ef4444' : 'var(--text)' }}>{r.stage}</td>
                      <td style={{ padding:'0.5rem 0.75rem', fontSize:'0.78rem', color:'var(--text-muted)', fontVariantNumeric:'tabular-nums' }}>{r.result}</td>
                      <td style={{ padding:'0.5rem 0.75rem', fontSize:'0.78rem', color:'var(--text-muted)' }}>{r.notes}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function ScheduleTab() {
  const [grpFilter, setGrpFilter] = useState('All');
  const groups = ['All','A','B','C','D','E','F','G','H','I','J','K','L'];

  const grid = useMemo(() => {
    const g = {};
    MATCHES_RAW.forEach(m => {
      if (!g[m.date]) g[m.date] = {};
      if (!g[m.date][m.city]) g[m.date][m.city] = [];
      g[m.date][m.city].push({ type:'group', ...m });
    });
    KNOCKOUTS_RAW.forEach(k => {
      if (!g[k.date]) g[k.date] = {};
      if (!g[k.date][k.city]) g[k.date][k.city] = [];
      g[k.date][k.city].push({ type:'knockout', ...k });
    });
    return g;
  }, []);

  const allDates = grpFilter === 'All' ? [...DATES, ...KNOCKOUT_DATES] : DATES.filter(d =>
    MATCHES_RAW.some(m => m.date === d && m.grp === grpFilter)
  );

  const activeCities = useMemo(() => {
    if (grpFilter === 'All') return CITIES;
    const used = new Set(MATCHES_RAW.filter(m => m.grp === grpFilter).map(m => m.city));
    return CITIES.filter(c => used.has(c));
  }, [grpFilter]);

  return (
    <div>
      <div style={{ marginBottom:'1rem' }}>
        <div style={{ fontSize:'0.78rem', color:'var(--text-muted)', marginBottom:'0.5rem' }}>Filter by group:</div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:'0.4rem' }}>
          {groups.map(g => (
            <button key={g} onClick={() => setGrpFilter(g)} style={{ fontSize:'0.72rem', fontWeight:700, padding:'0.2rem 0.65rem', borderRadius:20, cursor:'pointer', border:`1px solid ${grpFilter===g ? (GRP_COLOR[g]||'var(--gold)') : 'var(--border)'}`, background: grpFilter===g ? ((GRP_COLOR[g]||'var(--gold)')+'22') : 'transparent', color: grpFilter===g ? (GRP_COLOR[g]||'var(--gold)') : 'var(--text-muted)' }}>
              {g === 'All' ? 'All Rounds' : `Group ${g}`}
            </button>
          ))}
        </div>
      </div>
      <div style={{ overflowX:'auto', WebkitOverflowScrolling:'touch' }}>
        <table style={{ borderCollapse:'collapse', minWidth: activeCities.length * 150 + 80 }}>
          <thead>
            <tr>
              <th style={{ padding:'0.5rem 0.75rem', textAlign:'left', fontSize:'0.7rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', position:'sticky', left:0, background:'var(--navy)', zIndex:2, minWidth:70, borderBottom:'1px solid var(--border)', borderRight:'1px solid var(--border)' }}>Date</th>
              {activeCities.map(c => (
                <th key={c} style={{ padding:'0.4rem 0.5rem', fontSize:'0.68rem', color:'var(--text-muted)', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.04em', textAlign:'center', minWidth:150, borderBottom:'1px solid var(--border)', borderRight:'1px solid var(--border)', whiteSpace:'nowrap' }}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allDates.map((date, ri) => {
              const isKnockout = KNOCKOUT_DATES.includes(date);
              return (
                <tr key={date} style={{ borderBottom:'1px solid var(--border)', background: isKnockout ? 'rgba(255,255,255,0.018)' : 'transparent' }}>
                  <td style={{ padding:'0.5rem 0.75rem', fontSize:'0.78rem', fontWeight:700, color: isKnockout ? 'var(--gold-dark, #c89420)' : 'var(--gold)', position:'sticky', left:0, background: isKnockout ? '#0e1d36' : 'var(--navy)', zIndex:1, borderRight:'1px solid var(--border)', whiteSpace:'nowrap' }}>{date}</td>
                  {activeCities.map(city => {
                    const entries = grid[date]?.[city] || [];
                    const groupMatches = entries.filter(e => e.type === 'group' && (grpFilter === 'All' || e.grp === grpFilter));
                    const knockoutEntries = grpFilter === 'All' ? entries.filter(e => e.type === 'knockout') : [];
                    return (
                      <td key={city} style={{ padding:'0.35rem 0.4rem', borderRight:'1px solid var(--border)', verticalAlign:'middle', background: ri%2===1 ? 'rgba(255,255,255,0.01)' : 'transparent' }}>
                        {groupMatches.map((m, mi) => (
                          <div key={mi} style={{ padding:'0.35rem 0.45rem', borderRadius:6, background:'var(--navy-light)', border:`1px solid ${GRP_COLOR[m.grp]||'var(--border)'}22`, marginBottom: mi < groupMatches.length-1 || knockoutEntries.length > 0 ? '0.3rem' : 0 }}>
                            <div style={{ fontSize:'0.62rem', color: GRP_COLOR[m.grp]||'var(--text-muted)', fontWeight:700, marginBottom:'0.15rem' }}>Grp {m.grp} · {m.time} ET</div>
                            <div style={{ fontSize:'0.75rem', fontWeight:700, lineHeight:1.3, textAlign:'center' }}>{m.t1}</div>
                            <div style={{ fontSize:'0.62rem', color:'var(--text-muted)', textAlign:'center' }}>vs</div>
                            <div style={{ fontSize:'0.75rem', fontWeight:700, lineHeight:1.3, textAlign:'center' }}>{m.t2}</div>
                          </div>
                        ))}
                        {knockoutEntries.map((k, ki) => {
                          const col = KNOCKOUT_COLOR[k.round] || '#2d3748';
                          return (
                            <div key={ki} style={{ padding:'0.35rem 0.45rem', borderRadius:6, background: col + '1a', border:`1px solid ${col}55`, textAlign:'center', marginBottom: ki < knockoutEntries.length-1 ? '0.3rem' : 0 }}>
                              <div style={{ fontSize:'0.72rem', fontWeight:800, color: col }}>{k.round}</div>
                              <div style={{ fontSize:'0.62rem', color:'var(--text-muted)', marginTop:'0.1rem' }}>TBD vs TBD</div>
                            </div>
                          );
                        })}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', marginTop:'0.75rem' }}>All times Eastern (ET). Final group matchday (Jun 24–27) both games kick off simultaneously.</div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// LIVE SCORES TAB
// ═══════════════════════════════════════════════

const GROUPS_LIST = ['A','B','C','D','E','F','G','H','I','J','K','L'];

function LiveScoresTab() {
  const { user } = useContext(AuthContext);
  const [scores, setScores] = useState({});
  const [editing, setEditing] = useState({});
  const [saving, setSaving] = useState(null);
  const [msg, setMsg] = useState('');

  const isAdmin = !!user?.is_admin;

  useEffect(() => {
    api.get('/scores').then(r => {
      const map = {};
      for (const s of r.data) map[s.match_key] = s;
      setScores(map);
    }).catch(() => {});
  }, []);

  const byGroup = {};
  for (const g of GROUPS_LIST) byGroup[g] = [];
  for (const m of MATCHES_RAW) {
    if (byGroup[m.grp]) byGroup[m.grp].push(m);
  }

  const handleSave = async (match) => {
    const key = `${match.t1}|${match.t2}`;
    const e = editing[key] || {};
    const hs = parseInt(e.home ?? '');
    const as_ = parseInt(e.away ?? '');
    if (isNaN(hs) || isNaN(as_) || hs < 0 || as_ < 0) return;
    setSaving(key);
    try {
      await api.post('/scores', {
        match_key: key,
        group_name: match.grp,
        home_team: match.t1,
        away_team: match.t2,
        home_score: hs,
        away_score: as_,
      });
      setScores(prev => ({ ...prev, [key]: { match_key: key, home_score: hs, away_score: as_, played: true } }));
      setEditing(prev => { const n = { ...prev }; delete n[key]; return n; });
      setMsg('Saved!'); setTimeout(() => setMsg(''), 2000);
    } catch { setMsg('Error saving.'); }
    setSaving(null);
  };

  const inputStyle = {
    width: 38, textAlign: 'center', padding: '3px 4px',
    background: 'var(--navy-light)', border: '1px solid var(--border)',
    borderRadius: 4, color: 'var(--text)', fontSize: '0.9rem',
  };

  return (
    <div>
      <p className="text-muted mb-2" style={{ fontSize: '0.85rem' }}>
        {isAdmin
          ? 'Enter scores as games finish — leaderboards update automatically.'
          : 'Live group stage scores, updated as games are played.'}
      </p>
      {msg && <div className="success-msg mb-2">{msg}</div>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(340px,100%), 1fr))', gap: '1rem' }}>
        {GROUPS_LIST.map(g => (
          <div key={g} className="card" style={{ padding: '1rem' }}>
            <h3 style={{ marginBottom: '0.75rem', fontSize: '1rem' }}>Group {g}</h3>
            {byGroup[g].map((m, i) => {
              const key = `${m.t1}|${m.t2}`;
              const s = scores[key];
              const e = editing[key];
              const isLast = i === byGroup[g].length - 1;
              return (
                <div key={key} style={{ marginBottom: isLast ? 0 : '0.6rem', paddingBottom: isLast ? 0 : '0.6rem', borderBottom: isLast ? 'none' : '1px solid var(--border)' }}>
                  <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>{m.date} · {m.city}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <span style={{ flex: 1, textAlign: 'right', fontSize: '0.83rem', fontWeight: s?.played ? 700 : 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.t1}</span>
                    {isAdmin ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '3px', flexShrink: 0 }}>
                        <input type="number" min="0" max="20" style={inputStyle}
                          value={e?.home !== undefined ? e.home : (s?.played ? s.home_score : '')}
                          onChange={ev => setEditing(prev => ({ ...prev, [key]: { ...prev[key], home: ev.target.value } }))}
                        />
                        <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>-</span>
                        <input type="number" min="0" max="20" style={inputStyle}
                          value={e?.away !== undefined ? e.away : (s?.played ? s.away_score : '')}
                          onChange={ev => setEditing(prev => ({ ...prev, [key]: { ...prev[key], away: ev.target.value } }))}
                        />
                        <button className="btn btn-primary btn-sm" onClick={() => handleSave(m)} disabled={saving === key} style={{ padding: '3px 8px', fontSize: '0.75rem' }}>
                          {saving === key ? '…' : 'Save'}
                        </button>
                      </div>
                    ) : (
                      <div style={{ minWidth: 52, textAlign: 'center', fontWeight: 700, fontSize: '0.95rem', flexShrink: 0 }}>
                        {s?.played ? `${s.home_score} – ${s.away_score}` : <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '0.8rem' }}>vs</span>}
                      </div>
                    )}
                    <span style={{ flex: 1, textAlign: 'left', fontSize: '0.83rem', fontWeight: s?.played ? 700 : 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.t2}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════
// MAIN PAGE
// ═══════════════════════════════════════════════
const TABS = [
  { id:'scores',     label:'⚽ Live Scores'      },
  { id:'rankings',   label:'📊 Rankings'        },
  { id:'schedule',   label:'📅 Schedule'         },
  { id:'facts',      label:'⚡ Fun Facts'        },
  { id:'squads',     label:'👕 Squads'           },
  { id:'odds',       label:'🎲 Odds'             },
  { id:'confed',     label:'🌍 By Confederation' },
  { id:'history',    label:'🏆 WC History'       },
  { id:'prize',      label:'💰 Prize Money'      },
  { id:'regional',   label:'🥇 Regional Cups'    },
  { id:'nation',     label:'📜 Nation History'   },
];

export default function FunFacts() {
  const [tab, setTab] = useState('scores');

  return (
    <div>
      {/* Hero */}
      <div style={{ background:'linear-gradient(135deg,#0a1628 0%,#1a2f55 50%,#0a1628 100%)', borderRadius:12, padding:'2rem', marginBottom:'1.5rem', border:'1px solid var(--border)', textAlign:'center' }}>
        <div style={{ fontSize:'2.5rem', marginBottom:'0.4rem' }}>🌍</div>
        <h1 style={{ fontSize:'1.8rem', fontWeight:800, marginBottom:'0.3rem' }}>World Cup 2026 — Facts & Stats</h1>
        <p style={{ color:'var(--text-muted)', maxWidth:500, margin:'0 auto', fontSize:'0.9rem' }}>Rankings, squads, odds, schedule, history — everything you need in one place.</p>
      </div>

      {/* Tab bar — scrollable */}
      <p style={{ fontSize:'0.75rem', color:'var(--text-muted)', textAlign:'right', marginBottom:'0.25rem' }}>← swipe to the right →</p>
      <div style={{ overflowX:'auto', WebkitOverflowScrolling:'touch', marginBottom:'1.5rem', paddingBottom:'2px' }}>
        <div style={{ display:'flex', gap:'0.25rem', minWidth:'max-content' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} className={`bracket-tab ${tab===t.id?'active':''}`} style={{ whiteSpace:'nowrap', fontSize:'0.82rem' }}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === 'scores'   && <LiveScoresTab />}
      {tab === 'rankings' && <Rankings />}
      {tab === 'facts'    && <FunFactsTab />}
      {tab === 'squads'   && <SquadsTab />}
      {tab === 'odds'     && <OddsTab />}
      {tab === 'confed'   && <ConfederationsTab />}
      {tab === 'history'  && <HistoryTab />}
      {tab === 'prize'    && <PrizeMoneyTab />}
      {tab === 'regional' && <RegionalCupsTab />}
      {tab === 'nation'   && <NationHistoryTab />}
      {tab === 'schedule' && <ScheduleTab />}
    </div>
  );
}
